// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"App__appWrapper___O0P9t"};